export default __webpack_public_path__ + "files/media/mmc@2x.acabc026.webp";